// extracted by mini-css-extract-plugin
export default {"tabList":"SvuqCKr8a0C6sN3OXpDm","panelEmphasized":"tkiZCCSa0hVZHnyeaEHY"};